import React from 'react'
import * as ROUTES from '../../../utils/constants/routes'
import {Link} from 'react-router-dom'
export default function Footer() {
    return (
        <footer className="footer-section white-bg pt-100">
        <div className="container">
            <div className="row">
                <div className="col-lg-3 col-md-6 col-sm-6">
                    <div className="single-footer-widget">
                        <h3>Contact info</h3>
                        <div className="footer-info-contact">
                            <i className="flaticon-pin"></i>
                            <h3>Location</h3>
                            <span>
                            205 Namungoona, Kampala
                                <br/>
                                Uganda, East Africa
                            </span>
                        </div>
                        <div className="footer-info-contact">
                            <i className="flaticon-call"></i>
                            <h3>Call Us</h3>
                            <span>
                               <a href="tel:+256-772-259323">256 772-259323 </a>
                            </span>
                            <br/>
                            <span>
                                <a href="tel:+256-414580708">256 414-580708 </a>
                            </span>
                            <br/>
                            <span>
                                <a href="tel:+256-706 080391">256 706-080391 </a>
                            </span>
                        </div>
                        <div className="footer-info-contact">
                            <i className="flaticon-email"></i>
                            <h3>Email Us</h3>
                            <span>
                                <a href="mailto:hello@childhope.com">hello@childhope.com</a>
                            </span>
                        </div>
                    </div>
                </div>
                <div className="col-lg-3 col-md-6 col-sm-6">
                    <div className="single-footer-widget">
                        <h3>Our support</h3>
                        <ul className="footer-quick-links">
                            <li>
                                <a href="#">
                                    Private Policies
                                </a>
                            </li>
                            <li>
                                <a href="#">
                                    Donate Now
                                </a>
                            </li>
                            <li>
                                <a href="#">
                                    Become a Volunteer
                                </a>
                            </li>
                            <li>
                                <a href="#">
                                    Careers
                                </a>
                            </li>
                            <li>
                            <Link to={ROUTES.CONTACT}>
                                    Contact Us
                             </Link>
                            </li>
                            <li>
                                <a href="#">
                                    Paid programs
                                </a>
                            </li>
                            <li>
                                <a href="#">
                                    Partnership
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="col-lg-2 col-md-6 col-sm-6">
                    <div className="single-footer-widget">
                        <h3>Our Services</h3>
                        <ul className="footer-quick-links">
                            <li>
                                <a href="#">
                                    Donate
                                </a>
                            </li>
                            <li>
                                <a href="#">
                                    Sponsor
                                </a>
                            </li>
                            <li>
                                <a href="#">
                                    Fundraise
                                </a>
                            </li>
                            <li>
                            <Link to={ROUTES.TEAM}>
                                    Volunteer
                                    </Link>
                            </li>
                            
                            <li>
                            <Link to={ROUTES.FAQ}>
                                    Faq
                            </Link>
                            </li>
                            <li>
                            <Link to={ROUTES.TEAM}>
                                    Team
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="col-lg-4 col-md-6 col-sm-6">
                    <div className="single-footer-widget">
                        <h3>Recent News</h3>
                        <div className="footer-news">
                            <a href="#">
                                <img src="./assets/img/footer-news/1.jpg" alt="Support about poverty to poor family<"/>
                                <h4>Support about poverty to poor family</h4>
                                <span>Poor, 22 January</span>
                            </a>
                        </div>
                        <div className="footer-news">
                            <a href="#">
                                <img src="./assets/img/footer-news/2.jpg" alt="Mostly suffered school Boys care"/>
                                <h4>Mostly suffered school Boys care</h4>
                                <span>Health, 24 February</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="copyright-area">
            <div className="container">
                <div className="copyright-area-content">
                    <div className="row align-items-center">
                        <div className="col-lg-4">
                            <div className="copyright-logo">
                                <img src="./assets/img/logo-child-2.png" alt="Logo"/>
                            </div>
                        </div>

                        <div className="col-lg-4 col-md-6">
                            <p>
                                <i className="far fa-copyright"></i>
                                {new Date().getFullYear()} ChildHope Foundation. All Rights Reserved 
                                
                            </p>
                        </div>

                        <div className="col-lg-4 col-md-6">
                            <ul>
                                <li>
                                    <a href="#">Terms
                                        &amp; Conditions</a>
                                </li>
                                <li>
                                    <a href="#">Privacy
                                        Policy</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </footer>
    )
}
